import { useEffect } from 'react';
import { useSelectMatterRequestUser } from '../../hooks/useSelectMatterRequestUser';
import { Radio, RadioGroup, Spin, Text } from '../Ant';
import NoData from '../dashboard/noData';
import { GeneralEmpty } from '../icons';
import SearchInputWithFilters from '../dashboard/SearchInputWithFilters';
import { usePage } from '../../context/PageContext';
import AddEditTransactionHeader from '../dashboard/addTransaction/addEditTransactionHeader';
import { useNavigationStack } from '../../context/NavigationStackContext';
import SkeletonOptionList from '../common/skeleton/skeletonOptionList';
import CollapsibleListLayout from '../collapsibleListLayout/collapsibleListLayout';
import { IUser } from '../../interface/user';

const SelectMatterRequestUser = () => {
  const {
    t,
    title,
    userList,
    isLoading,
    isFetching,
    setSearchValue,
    paginationRef,
    hasNextPage,
    refreshUserList,
    handleSelectUser,
    currentValue,
  } = useSelectMatterRequestUser();
  const { setTitle } = usePage();
  const { goBack } = useNavigationStack();

  const handleBack = () => {
    goBack();
  };

  useEffect(() => {
    setTitle(<AddEditTransactionHeader handleBack={handleBack} showCross title={title} />);
  }, [title]);

  return (
    <CollapsibleListLayout
      testId="matter-request-user-selection"
      header={
        <SearchInputWithFilters
          searchTitle={t('common:searchUsers')}
          handleSearch={(val) => setSearchValue(val)}
          handleRefresh={refreshUserList}
        />
      }
    >
      {userList && userList.length > 0 && (
        <RadioGroup
          data-testid="radio-group"
          className="d-flex fd-column gap-10"
          value={currentValue}
        >
          {userList.map((user: IUser) => (
            <Radio
              key={user.id}
              value={user.id}
              data-testid={`user-radio-${user.id}`}
              onClick={() => handleSelectUser(user)}
            >
              <Text $fontsize="13px" $color="title" $weight={500} $lineheight="20px">
                {user.fullName}
              </Text>
            </Radio>
          ))}
        </RadioGroup>
      )}
      {hasNextPage && <div ref={paginationRef} className="loading-indicator" />}
      {(!userList || (userList.length === 0 && !isLoading)) && (
        <div
          className="flex-grow d-flex justify-center items-center"
          role="status"
          aria-live="polite"
        >
          <NoData
            header={t('common:noUsersFound')}
            subHeader={t('common:tryChangingSearchCriteria')}
            icon={<GeneralEmpty />}
          />
        </div>
      )}
      {isLoading ? (
        <SkeletonOptionList />
      ) : (
        isFetching && <Spin size="small" data-testid="small-indicator" />
      )}
    </CollapsibleListLayout>
  );
};

export default SelectMatterRequestUser;
